/** Signed-in dashboard (grid) — not an active chat thread. */
export const APP_HOME_PATH = "/home";

/** Active chat conversation UI. */
export const CHAT_PATH = "/chat";
